/**
 * 轮询事件
 */
class PollingEvent {
  private isStart: boolean = false;
  private timer: null | number = null;
  private tryTimes: number = 0;

  /**
   * @param interval : 间隔时间
   * @param event ：获取用户名事件
   * @param maxTimes ：最大尝试次数
   */
  start(interval: number, event: () => void, maxTimes: number) {
    if (this.isStart) return;
    this.isStart = true;
    this.timer = window.setInterval(() => {
      try {
        if (this.tryTimes < maxTimes) {
          event();
          this.tryTimes++;
        } else {
          this.clear();
        }
      } catch (err) {
        this.clear();
      }
    }, interval);
  }

  clear() {
    if (this.timer) {
      clearInterval(this.timer);
      this.isStart = false;
    }
  }
}

export default PollingEvent;
